import { useTranslate } from "@tolgee/react";
import {
  Capabilities,
  EmailTemplateContext,
} from "../../../../clients/graphqlTypes.js";

const CONTEXTS: Array<{
  type: EmailTemplateContext;
  capability?: Capabilities;
}> = [
  { type: "PROJECT" },
  { type: "QUOTE" },
  { type: "REQUIREMENT", capability: "REQUIREMENTS" },
  { type: "CRM" },
];

export function useEmailTemplateContexts() {
  const { t } = useTranslate(["OrganisationSettings"]);

  const labels: Record<EmailTemplateContext, string> = {
    PROJECT: t("Project", { ns: "OrganisationSettings" }),
    QUOTE: t("Quote", { ns: "OrganisationSettings" }),
    REQUIREMENT: t("Requirement", { ns: "OrganisationSettings" }),
    CRM: t("CRM", { ns: "OrganisationSettings" }),
  };

  const options = CONTEXTS.map(({ type, capability }) => ({
    value: type,
    label: labels[type],
    capability,
  }));

  return { labels, options };
}
